var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "renewing-membership membership-options" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-md-12 " },
            [
              _c(
                "h6",
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.configOptions[
                          "renewal-label-additional-contribution"
                        ]
                      ) +
                      "\n          "
                  ),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: { effect: "dark", placement: "right" },
                    },
                    [
                      _c("div", {
                        attrs: { slot: "content" },
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.configOptions[
                              "renewal-info-additional-contribution"
                            ]
                          ),
                        },
                        slot: "content",
                      }),
                      _vm._v(" "),
                      _c("i", {
                        staticClass: "fas fa-info-circle",
                        attrs: { title: "" },
                      }),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("p", {
                staticClass: "font-weight-light",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.configOptions["renewal-additional-contribution"]
                  ),
                },
              }),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  staticClass: "donation-settings",
                  nativeOn: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c("el-alert", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.amountError.show,
                        expression: "amountError.show",
                      },
                    ],
                    attrs: {
                      title: _vm.amountError.message,
                      type: "error",
                      "show-icon": "",
                    },
                    on: {
                      close: function ($event) {
                        _vm.amountError = false
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm.donationOptions["allow-monthly-donation"]
                    ? _c(
                        "el-button-group",
                        { staticClass: "toggle-options w-50" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: _vm.AllowMonthlyDonation
                                  ? "plain"
                                  : "primary",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.toggleFrequency("once")
                                },
                              },
                            },
                            [_vm._v("Once Only")]
                          ),
                          _vm._v(" "),
                          _vm.donationOptions["allow-monthly-donation"]
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: _vm.AllowMonthlyDonation
                                      ? "primary"
                                      : "plain",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleFrequency("monthly")
                                    },
                                  },
                                },
                                [_vm._v("Monthly")]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "d-flex" }, [
                    _c(
                      "div",
                      { staticClass: "flex-fill select-amount-box" },
                      [
                        _c("p", [_vm._v("Select amount")]),
                        _vm._v(" "),
                        _c(
                          "el-radio-group",
                          {
                            attrs: { size: "medium" },
                            on: { change: _vm.onSelectAmount },
                            model: {
                              value: _vm.donationAmount,
                              callback: function ($$v) {
                                _vm.donationAmount = $$v
                              },
                              expression: "donationAmount",
                            },
                          },
                          _vm._l(_vm.getAmountLists, function (gift, i) {
                            return _c("el-radio", {
                              key: i,
                              attrs: {
                                label:
                                  typeof gift === "object"
                                    ? "$" + gift["gift-amount"]
                                    : "$" + gift,
                                border: "",
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "align-self-center mx-4 text-primary" },
                      [_vm._v("Or")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex-fill custom-amount-box" },
                      [
                        _c("p", [_vm._v("Choose your own amount")]),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { staticClass: "custom-input" },
                          [
                            _c("img", {
                              staticClass: "dollar-sign",
                              attrs: {
                                src: require("../../assets/icons/dollar.svg"),
                                alt: "",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-input", {
                              attrs: { placeholder: "Enter amount" },
                              model: {
                                value: _vm.customAmount,
                                callback: function ($$v) {
                                  _vm.customAmount = _vm._n($$v)
                                },
                                expression: "customAmount",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-checkbox",
                {
                  model: {
                    value: _vm.eligibleChecked,
                    callback: function ($$v) {
                      _vm.eligibleChecked = $$v
                    },
                    expression: "eligibleChecked",
                  },
                },
                [
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.donationOptions["eligibility-text-individual"]
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "font-weight-bold",
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          _vm.disclosureState = true
                        },
                      },
                    },
                    [_vm._v("Disclosure statement")]
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _vm.showRemoveButton
          ? _c(
              "div",
              [
                _c(
                  "el-link",
                  {
                    attrs: {
                      icon: "el-icon-error",
                      underline: false,
                      type: "danger",
                    },
                    on: { click: _vm.clearDonation },
                  },
                  [_vm._v("Remove donation")]
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "dialog-popup",
          attrs: { visible: _vm.disclosureState },
          on: {
            "update:visible": function ($event) {
              _vm.disclosureState = $event
            },
          },
        },
        [
          _c("div", {
            domProps: {
              innerHTML: _vm._s(_vm.donationOptions["disclosure-content"]),
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "renewal-btn d-flex flex-wrap" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "secondary" },
              on: {
                click: function ($event) {
                  return _vm.setStep(1)
                },
              },
            },
            [_c("i", { staticClass: "el-icon-back" }), _vm._v(" BACK")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
            [
              _vm._v("NEXT "),
              _c("i", { staticClass: "el-icon-arrow-right el-icon-right" }),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }